import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { Dialog } from '../../Dialog';
import { FormGroup } from '../../FormGroup';
import { FormRow } from '../../FormRow';
import { RadioButtons } from '../../RadioButtons';
import { selectNexaTransmitter } from '../../../reducers/nexaTransmittersSlice';
import { saveNexaTransmitter } from '../../../actions/SaveNexaTransmitter';
import { parseInteger } from '../../../util/parseInteger';
import { createNexaTransmitter } from '../../../actions/CreateNexaTransmitter';
import { deleteNexaTransmitter } from '../../../actions/DeleteNexaTransmitter';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa s\u00E4ndare" }));
export const DialogNexaTransmitterEdit = (props) => {
    const dispatch = useAppDispatch();
    const [title, setTitle] = useState('');
    const [kind, setKind] = useState('onoff');
    const [code, setCode] = useState('');
    const [unit, setUnit] = useState('');
    const [comment, setComment] = useState('');
    const transmitter = useAppSelector(selectNexaTransmitter(props.id == 'new' ? undefined : props.id));
    const saveHandler = () => {
        const codeAsNum = parseInteger(code);
        const unitAsNum = parseInteger(unit);
        if (transmitter == undefined || codeAsNum == undefined || unitAsNum == undefined) {
            return;
        }
        const t = {
            id: transmitter.id,
            title,
            kind,
            code: codeAsNum,
            unit: unitAsNum,
            comment,
            created: transmitter.created
        };
        dispatch(saveNexaTransmitter(t, () => props.onClose()));
    };
    const createHandler = () => {
        const codeAsNum = parseInteger(code);
        const unitAsNum = parseInteger(unit);
        if (codeAsNum == undefined || unitAsNum == undefined) {
            return;
        }
        const t = {
            title,
            kind,
            code: codeAsNum,
            unit: unitAsNum,
            comment
        };
        dispatch(createNexaTransmitter(t, () => props.onClose()));
    };
    const deleteHandler = () => {
        if (transmitter != undefined) {
            dispatch(deleteNexaTransmitter(transmitter.id, () => props.onClose()));
        }
    };
    useEffect(() => {
        if (transmitter == undefined) {
            setTitle('');
            setKind('onoff');
            setCode('');
            setUnit('');
            setComment('');
        }
        else {
            setTitle(transmitter.title);
            setKind(transmitter.kind);
            setCode(transmitter.code.toString());
            setUnit(transmitter.unit.toString());
            setComment(transmitter.comment);
        }
    }, [transmitter, props.id, props.isOpen]);
    let footerleft, footerright;
    const radiobuttons = [
        { kind: 'onoff', title: 'På/Av' },
        { kind: 'dimmer', title: 'Dimmer' },
    ];
    if (props.id != 'new') {
        footerleft = (_jsx(DeleteButton, { onClick: () => deleteHandler() }, "delete"));
        footerright = [
            (_jsx(CancelButton, { onClick: () => props.onClose() }, "cancel")),
            (_jsx(SaveButton, { onClick: () => saveHandler() }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => props.onClose() }, "cancel")),
            (_jsx(CreateButton, { onClick: () => createHandler() }, "create"))
        ];
    }
    const dialogTitle = props.id == 'new' ? 'Skapa sändare' : 'Redigera sändare';
    return (_jsxs(Dialog, { title: dialogTitle, isOpen: props.isOpen, footerleft: footerleft, footerright: footerright, close: props.onClose, children: [_jsx(FormRow, { children: _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: title, onChange: event => setTitle(event.target.value) }) }) }), _jsx(FormRow, { children: _jsx(RadioButtons, { buttons: radiobuttons, name: 'kind', kind: kind, updateKind: (v) => setKind(v) }) }), _jsx(FormRow, { children: _jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr' }, children: [_jsx("div", { style: { marginRight: '15px' }, children: _jsx(FormGroup, { label: "Kod", children: _jsx("input", { type: "text", name: "code", value: code, onChange: event => setCode(event.target.value) }) }) }), _jsx("div", { style: { marginLeft: '15px' }, children: _jsx(FormGroup, { label: "Knapp", children: _jsx("input", { type: "text", name: "unit", value: unit, onChange: event => setUnit(event.target.value) }) }) })] }) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Kommentar", children: _jsx("input", { type: "text", name: "comment", value: comment, onChange: event => setComment(event.target.value) }) }) }), _jsx("input", { name: "transmitter_id", type: "hidden", value: props.id })] }));
};
